<template>
  <div class="deposit-container">
    <div class="content">
      <h2>Choose deposit method</h2>

      <div class="row">
        <div class="vendor">FUNDING METHOD</div>
        <div class="processing">PROCESSING TIME</div>
        <div class="fee">FEE</div>
        <div class="arrow-right"></div>
      </div>

      <InfoRowButton icon="/assets/images/cabinet_cards.svg" method="Credit cards" processing="Instant 24/7"
                     fee="0%" @click="creditCards"></InfoRowButton>
      <InfoRowButton icon="/assets/images/cabinet_cards.svg" method="Alternative methods" processing="Instant 24/7"
                     fee="0%" @click="chooseAlternativeMethods"></InfoRowButton>

      <InfoRowButton logo="/assets/images/logo_skrill.svg" method="" processing="Instant 24/7" fee="0%"
                     @click="addFunds('SKRILL')"></InfoRowButton>
      <InfoRowButton logo="/assets/images/logo_neteller.svg" method="" processing="Instant 24/7"
                     fee="0%" @click="addFunds('NETELLER')"></InfoRowButton>
      <InfoRowButton logo="/assets/images/logo_bit_wallet.svg" method="" processing="Instant 24/7"
                     fee="0%" @click="addFunds('BITWALLET')"></InfoRowButton>
      <InfoRowButton logo="/assets/images/logo_ecopayz.svg" method="" processing="Instant 24/7" fee="0%"
                     @click="addFunds('ECOPAYZ')"></InfoRowButton>
      <InfoRowButton logo="/assets/images/logo_tronipay.svg" method="" processing="Instant 24/7"
                     fee="0%" @click="addFunds('TRONIPAY')"></InfoRowButton>

      <InfoRowButton icon="/assets/images/cabinet_bank.svg" method="Bank transfer" processing="3 - 5 days" fee="0%"
                     @click="chooseBank"></InfoRowButton>
    </div>

    <p class="method-instructions">
      Losses can exceed initial amount invested | Third party payments will NOT be accepted. All deposits MUST be from
      the original account owner.
      <br>
      The trading platform's denomination is in USD | TVF reserves the right to bookback/refund any deposits made via
      Credit Card in lieu of a withdrawal.
    </p>
  </div>
</template>

<script>
import InfoRowButton from "@/components/InfoRowButton";

export default {
  name: "Deposit",
  components: {
    InfoRowButton
  },
  methods: {
    creditCards() {
      this.$router.push('/cabinet/console/add_credit_card_funds').catch(err => {
      });
    },
    chooseAlternativeMethods() {
      this.$router.push('/cabinet/console/choose_alternative_methods').catch(err => {
      });
    },
    chooseBank() {
      this.$router.push('/cabinet/console/choose_banks').catch(err => {
      });
    },
    addFunds(target) {
      this.$router.push('/cabinet/console/add_funds/' + target).catch(err => {
      });
    }
  }
}
</script>

<style scoped>

</style>
